import { render, staticRenderFns } from "./PointRecord.vue?vue&type=template&id=04637ddc&"
import script from "./PointRecord.vue?vue&type=script&lang=js&"
export * from "./PointRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports